document.addEventListener("DOMContentLoaded", function () {

    /// product card images slider
    if (document.querySelector('.product-card .card-product-slider')) {
        new Swiper('.product-card .card-product-slider', {
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.pro-card-arrows',
                prevEl: '.swiper-button-prev.pro-card-arrows',
            },
            slidesPerView: 1,
            paginationClickable: true,
            spaceBetween: 10
        });
    }
  
    /// images gallery slider
    if (document.querySelector('.images-gallery-section .swiper-container')) {
        new Swiper('.images-gallery-section .swiper-container', {
            loop: true,
            slidesPerView: 1,
            paginationClickable: true,
            autoHeight: true,
            spaceBetween: 20,
            pagination: {
                el: '.swiper-pagination-gallery',
                clickable: true
            },
        });
    }

    /// customer review section slider
    if (document.querySelector('.testimonial-section .swiper-container')) {
        new Swiper('.testimonial-section .swiper-container', {
            loop: true,
            slidesPerView: 3,
            paginationClickable: true,
            autoHeight: true,
            spaceBetween: 20,
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    autoHeight: true,
                    spaceBetween: 21
                },
                749: {
                    slidesPerView: 2,
                    autoHeight: true,
                    spaceBetween: 16,
                    pagination: {
                        el: '.swiper-pagination-customer-review-block',
                        clickable: true
                    },
                },
                0: {
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination-customer-review-block',
                        clickable: true
                    },
                    autoHeight: true,
                    spaceBetween: 16
                }
            }
        });
    }

    /// product page description show more/less functionality
    const description = document.querySelector(".pro-description-show-more-less");
    const button = document.querySelector(".toggle-description-btn");

    if (description && button) {
        button.addEventListener("click", function () {
            description.classList.toggle("expanded");
        });
    }

});


function initProductSliders() {
  document.querySelectorAll('.card-product-slider').forEach(slider => {
    if (!slider.classList.contains('swiper-initialized')) {
      new Swiper(slider, {
        loop: true,
        navigation: {
          nextEl: slider.closest('.product-card__figure')?.querySelector('.swiper-button-next') || '.swiper-button-next.pro-card-arrows',
          prevEl: slider.closest('.product-card__figure')?.querySelector('.swiper-button-prev') || '.swiper-button-prev.pro-card-arrows'
        },
        slidesPerView: 1,
        spaceBetween: 10,
        paginationClickable: true
      });
    }
  });
}

// Run on initial load
document.addEventListener('DOMContentLoaded', initProductSliders);

// Re-run when Recently Viewed section updates (AJAX load)
const observer = new MutationObserver(initProductSliders);
observer.observe(document.body, { childList: true, subtree: true });
